(function(angular){
    'use strict';

    angular.module('onvio.setup').controller('onvio.setup.terms.TermsAndConditionsController', termsAndConditions);
    termsAndConditions.$inject = ['$rootScope', '$state', 'bmLanguageManager', 'bluemoon.components.Notifications'];

    function termsAndConditions($rootScope, $state, bmLanguageManager, Notifications){
        /*jshint validthis:true */
        var vm = this;
        vm.languages = [];
        vm.tabSelect = tabSelect;
        vm.tabDeselect = tabDeselect;
        vm.selectedTab = 0;

        var selectedLanguage;

        //////////

        bmLanguageManager.getLanguagesAsync(true).then(function(languages){

            vm.languages = languages;

            var indexOfCurrentLanguage = vm.languages.map( function(e){ return e.code; } ).indexOf(bmLanguageManager.getCurrentLanguage());

            vm.selectedTab = indexOfCurrentLanguage === -1 ? 0 : indexOfCurrentLanguage;
            selectedLanguage = indexOfCurrentLanguage === -1 ? vm.languages[0] : vm.languages[indexOfCurrentLanguage];
        });

        // no longer necessary as code was changed to reload the app on language change
        // Update dynamic strings on any lanuage change
        // $rootScope.$on('bmLanguageChangeSuccess', function(){
        //     // Save any screen changes before the view is reloaded
        //     selectedLanguage.saveChanges().then(function(){
        //         // Hack to get the wysiwyg editor to reload buttons with correct translations on a language change
        //         $state.forceReload();
        //     }, function(){
        //         // Reload even if there was an error
        //         $state.forceReload();
        //     });
        // });

        function tabDeselect(language){
            language.saveChanges().then(function(){
                resetNotifications();
            });
        }

        function tabSelect(language){
            selectedLanguage = language;
            resetNotifications();
        }

        function resetNotifications(){
            // Clear out any notifications
            Notifications.setError(null);
            Notifications.setInfo(null);
        }
    }
})(window.angular);
